import {CandidateStore} from './CandidateStore'
import {QuestionStore} from './QuestionStore'
import {AnswerStore} from './AnswerStore'
import {AuthStore} from './AuthStore'
import {PartyStore} from './PartyStore'
import {NotificationStore} from './NotificationStore'
import {ConstituencyStore} from './ConstituencyStore'

export class Stores {
  public constituencyStore: ConstituencyStore
  public candidateStore: CandidateStore
  public questionStore: QuestionStore
  public answerStore: AnswerStore
  public authStore: AuthStore
  public notificationStore: NotificationStore
  public partyStore: PartyStore

  constructor() {
    this.constituencyStore = new ConstituencyStore()
    this.notificationStore = new NotificationStore()
    this.questionStore = new QuestionStore()
    this.answerStore = new AnswerStore(this.notificationStore)
    this.candidateStore = new CandidateStore(this.notificationStore, this.questionStore, this.answerStore)
    this.authStore = new AuthStore(this)
    this.partyStore = new PartyStore()
  }
}
